var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"text":_vm.title,"variant":"primary"}},_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":_vm.active == item.value},on:{"click":function($event){return _vm.changed(item)}}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }